import run from '../../utilities/run';
import $ from 'jquery';
const _ = require("underscore");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run(".retailers_partner-details-page", ()=>{
	const el = $(".retailers_partner-details-page");

	const editPartnerUrl = el.data("edit-channel-connection-url");
	const inactivateRetPartnerUrl = el.data("inactivate-channel-url");
	const activateChannelUrl = el.data("activate-channel-url");
	const viewConnectionDetailUrl = el.data("view-channel-connection-detail-url");
	const retpartnerJson = el.data("retailer-partners-detail-info");
	const viewChannelDetailUrl = el.data("view-channel-detail-url");
	const modalInactivateChannel = $("#modalInactivateChannel");
	const modalActivateChannel = $("#modalActivateChannel");
	const ftpINB=el.data("ftp-inb-details");
	const ftpInboundFoldersTable=el.find('#inb_records_table');
	const ftpOUB=el.data("ftp-oub-details");
	const ftpOutboundFoldersTable=el.find('#oub_records_table');
	const retailerPartnerFileFormat=el.data("retailer-partner-file-format");
	let retailerSelectedFileFormat=retailerPartnerFileFormat.fileFormat;
	const submitModalFlow = new SubmitModalFlow();
	submitModalFlow.init();
	
	
	onLoad();

	function onLoad(){
		fillInboundFoldersData(ftpINB);
		fillOutboundFoldersData(ftpOUB);
		$('#channel-file-format').text(retailerSelectedFileFormat);
	}


	$(".inactivate").on( "click", function() {
		$("#deleteModal").appendTo("body").modal("show");
	});
	
	$(".activate").on( "click", function() {
		$("#activateModal").appendTo("body").modal("show");
	});

	modalInactivateChannel.on( "click", function() {
		inactivateRetPartner();
	});

	modalActivateChannel.on( "click", function() {
		activateRetailerPartner();
	});

	function inactivateRetPartner() {
		submitModalFlow.showLoadingModal();
		$.ajax({ 
			url: inactivateRetPartnerUrl,
			success: function(data){ 
				if(data.match("success")){
				  submitModalFlow.showSuccessModal();
				  setTimeout(function() {	
					location.href=viewChannelDetailUrl;
				  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
				}else{
					submitModalFlow.showFailureModal();
				}
			},
			error: function(data) {
				submitModalFlow.showFailureModal();
			}
		});	
 	}

 	function activateRetailerPartner() {
		submitModalFlow.showLoadingModal();
		$.ajax({ 
			url: activateChannelUrl,
			success: function(data){ 
				if(data.match("success")){
				  submitModalFlow.showSuccessModal();
				  setTimeout(function() {	
					location.href=viewChannelDetailUrl;
				  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
				}else{
					submitModalFlow.showFailureModal();
				}
			},
			error: function(data) {
				submitModalFlow.showFailureModal();
			}
		});	
	}

	function fillInboundFoldersData(ftpINB){
		ftpINB.forEach(function(ftpINB){ 
			var ftp_inb_folders = ftpINB.cdmValue;
			var trHTML = '';
			trHTML += '<tr><td>' + ftpINB.cdmValue + '</td></tr>'
			ftpInboundFoldersTable.append(trHTML);
		});
	}

	function fillOutboundFoldersData(ftpOUB){
		ftpOUB.forEach(function(ftpOUB) 
		{ 
			var ftp_oub_folders = ftpOUB.cdmValue;
			var trHTML = '';
			trHTML += '<tr><td>' + ftpOUB.cdmValue + '</td></tr>'
			ftpOutboundFoldersTable.append(trHTML);
		});
	}

});


// WEBPACK FOOTER //
// ./src/pages/createChannel/details.js